export default __webpack_public_path__ + "static/media/UploadFile.9b35c509.svg";